<template>
  <div
    class="flex flex-wrap align-center"
    data-qa="tenders-actions-snackbar">
    <div>
      <CopyTender
        v-if="showActions.copyItem"
        :tender="first"
        without-bid/>
    </div>
    <div>
      <ToggleTemplates
        v-if="showActions.template"
        :add="!inTemplates.length"
        @click="toTemplate"/>
    </div>
    <div>
      <DeleteTender
        :show="showActions.deleteTender"
        :tender="first"
        @callback="closeCancelTender"/>
    </div>
    <div>
      <ReturnToRegistrationConfirmation
        v-if="showActions.editTender"
        btn
        :item="first"/>
    </div>
    <div>
      <DownloadComparisonTable
        v-if="showActions.comparisonTable"
        :tender="first"/>
    </div>
  </div>
</template>
<script>
import CopyTender from 'components/tenders/dialogs/CopyTender.vue'
import DeleteTender from 'components/tenders/dialogs/DeleteTender.vue'
import ToggleTemplates from 'components/common/elements/ToggleTemplates.vue'
import DownloadComparisonTable from 'components/tenders/tender page/DownloadComparisonTable.vue'
import ReturnToRegistrationConfirmation from 'components/tenders/dialogs/ReturnToRegistrationConfirmation.vue'

import { snackbarMixin, tenderMixin } from 'mixins'

// import SmarttenderApi from '@/api/smarttenderApi'
// const st_api = new SmarttenderApi()

export default {
  name: 'tendersActionsToolbar',
  mixins: [tenderMixin, snackbarMixin],
  props: {
    options: Object
  },
  computed: {
    showActions() {
      const result = {
        copyItem: this.single && this.$acl.check('onlyTenders'),
        deleteTender: this.single && this.can_edit,
        editTender: this.single && this.can_edit &&
          (this.first.tenderStatusId == 1 ||
          (this.first.tenderStatusId == 4 && !this.first.hasBids && !this.first.participantCount && !this.first.bidsCount)),
        comparisonTable: this.single,
        cancelTendern: this.single && this.can_edit,
        template: !this.inTemplates || !this.inTemplates.length || (this.inTemplates.length == this.elements.length),
        toolbar: false,
      }

      result.toolbar = !!Object.values(result)?.filter(i => i)?.length
      this.$emit('showActions', result)
      return result
    },
    inTemplates() {
      return this.elements.filter(el => el.isTemplate)
    },
    single() {
      return this.elements.length == 1
    },
    elements() {
      return this.options.elements || []
    },
    first() {
      return this.elements[0] || {}
    },
    can_edit() {
      return this.$_checkCanEdit(this.first, this.$_agreements)
    },
  },
  methods: {
    toTemplate() {
      this.elements.forEach(element => {
        this.toggleTemplateInMainPage(element)
      })
      this.closeCancelTender()
    },
    closeCancelTender() {
      this.options.callback()
      this.$_closeSnackbar()
    },
    editTender() {
      this.$store.commit('setNewTenderInfo', {mode: 'edit', step: 1 })
      this.$router.push({
        name: 'editTender',
        query: {id: this.first.tenderId},
        params: {org: this.$route.params.org}
      })
    },
  },
  components: {
    CopyTender,
    DeleteTender,
    ToggleTemplates,
    DownloadComparisonTable,
    ReturnToRegistrationConfirmation
  }
}
</script>
